// CMS Technical Reference Architecture conformance client (/api/tra).
//
// Every principle carries the AIEA records it was scored from and, where it
// cannot be answered, the field that is missing. Show the gap — a conformance
// screen that only reports what passed is the one nobody trusts twice.

import { get } from "./http";

/** Estate-wide conformance against the thirteen FD_0020 foundation principles. */
export const getConformance = () => get("/tra/conformance");

/** The principle reference without scoring. */
export const getPrinciples = () => get("/tra/principles");

/** MEGABYTE Act evidence and the FITARA categories AIEA can speak to. */
export const getMegabyte = () => get("/tra/megabyte");
